import React from "react";

const IconButton = ({ onClick = () => {}, Icon = null }) => {
  const handleButtonClick = (event) => {
    event.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  return (
    <span className="Icon-btn" onClick={handleButtonClick}>
      {Icon}
    </span>
  );
};

export default IconButton;
